const PL_ROW_HEIGHT = 24;
const PL_OVERHEAD_PX = 150;
const PL_EXTRA_ROWS = 3;

export function computeInitialDrillDowns(plStructure, windowHeight) {
  if (!plStructure || !plStructure.length) return [];

  const availableHeight = windowHeight - PL_OVERHEAD_PX;

  const lookup = {};
  plStructure.forEach((line) => {
    lookup[line.meta_name] = line;
  });

  const countVisibleLines = (openSet) => {
    let count = PL_EXTRA_ROWS;
    for (const line of plStructure) {
      if (!line.parent) {
        count++;
        continue;
      }
      let current = line;
      let visible = true;
      while (current.parent) {
        if (!openSet.has(current.parent)) {
          visible = false;
          break;
        }
        current = lookup[current.parent];
        if (!current) {
          visible = false;
          break;
        }
      }
      if (visible) count++;
    }
    return count;
  };

  const allParents = plStructure
    .filter((l) => l.is_parent)
    .map((l) => l.meta_name);

  if (
    countVisibleLines(new Set(allParents)) * PL_ROW_HEIGHT <=
    availableHeight
  ) {
    return allParents;
  }

  const topLevelParents = plStructure
    .filter((l) => l.is_parent && !l.parent)
    .map((l) => l.meta_name);

  if (
    countVisibleLines(new Set(topLevelParents)) * PL_ROW_HEIGHT <=
    availableHeight
  ) {
    return topLevelParents;
  }

  return [];
}
